import React from 'react';
import { connect } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroller';
import { formValueSelector, arrayPush, change } from 'redux-form';
import { applySetItemItemsRequest } from 'actions/library/modifier';
import styles from './Items.css';

class Items extends React.Component {
  render() {
    const { items } = this.props;
    return (
      <div className={styles.wrapper}>
        <InfiniteScroll
          pageStart={1}
          loadMore={this._onReachBottom}
          hasMore={this._hasMore()}
          useWindow={false}
          threshold={10}
          initialLoad={false}
        >
          {items.map((item, idx) => (
            <div className={`row ${styles['row-wrapper']}`}>
              <div
                key={idx}
                className={`col-xs-2 ${styles['item-image-wrapper']}`}
              >
                <img src={item.image.url} className={styles.image} />
              </div>
              <div className={`col-xs-9 ${styles['item-name-wrapper']}`}>
                {item.name}
              </div>
              <div
                className={`col-xs-1 pull-right ${
                  styles['item-checkbox-wrapper']
                }`}
              >
                <input
                  type="checkbox"
                  checked={this._checked(item)}
                  onChange={e => this._onChangeCheckbox(e, item)}
                />
              </div>
            </div>
          ))}
        </InfiniteScroll>
      </div>
    );
  }

  _hasMore = () => {
    const { currentPage, totalPage } = this.props;
    const ret = currentPage < totalPage;
    return ret;
  };

  _onReachBottom = () => {
    const {
      currentPage,
      totalPage,
      applySetItem: { keyword },
      items,
      dispatch,
    } = this.props;
    if (currentPage < totalPage) {
      dispatch(
        applySetItemItemsRequest(
          { keyword, page: currentPage + 1, with_batch: true },
          items
        )
      );
    }
  };

  _onChangeCheckbox = (e, item) => {
    const {
      applySetItem: { itemIds },
      dispatch,
    } = this.props;
    const indexPositions = {};

    itemIds.forEach((itemId, index) => {
      if (itemId === item.id) {
        indexPositions[index] = true;
      }
    });
    if (e.target.checked) {
      dispatch(arrayPush('applySetItem', 'itemIds', item.id));
    } else {
      // remove all if exists (don't know why server has more than one
      const newItemIds = [];
      itemIds.forEach((itemId, index) => {
        if (!indexPositions[index]) {
          newItemIds.push(itemId);
        }
      });
      dispatch(change('applySetItem', 'itemIds', newItemIds));
    }
  };

  _checked = targetItem => {
    const {
      applySetItem: { itemIds },
    } = this.props;
    let checked = false;
    itemIds.forEach(itemId => {
      checked = checked || itemId === targetItem.id;
    });
    return checked;
  };
}

const selector = formValueSelector('applySetItem');

function mapStateToProps(state) {
  const {
    applySetItems: { items, currentPage, totalPage },
    modifierDetail,
  } = state.library.modifier;
  return {
    modifierDetail,
    applySetItem: {
      itemIds: selector(state, 'itemIds'),
      keyword: selector(state, 'keyword'),
    },
    items,
    currentPage,
    totalPage,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Items);
